import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PromoCodesTable from './Pages/PromoCodesTable/PromoCodesTable';
import { PromoCodesRoute } from './Constants/routes';
import { RouteProvider } from '@Providers/Routes/RoutesProvider';
import useInvalidateRouteGroup from '@Hooks/Routes/useInvalidateRouteGroup';

const PromoCodes = () => {
	const { path, url } = useRouteMatch();
	useInvalidateRouteGroup({
		baseURL: '/dashboard/promo-codes',
		mode: 'include',
		routeGroup: PromoCodesRoute,
	});
	return (
		<div>
			<RouteProvider path={path}>
				<Switch>
					<Route exact path={url} component={PromoCodesTable} />

					{PromoCodesRoute.routes.map((_) => {
						return (
							<Route key={_.route} path={`${path}/${_.route}`}>
								{_.component}
							</Route>
						);
					})}
				</Switch>
			</RouteProvider>
		</div>
	);
};

export default PromoCodes;
